<script lang="ts">
  import '../node_modules/milligram/dist/milligram.min.css';

  import ImageContainer from './components/ImageContainer.svelte';
  import AppHeader from './components/AppHeader.svelte';
  import AppFooter from './components/AppFooter.svelte';
  import {vote} from './domain/api';
  import {workflowExecutions} from './domain/store';

  import {Auth0Context, authToken, isAuthenticated,} from '@dopry/svelte-auth0';

  let showResult = true;

  function handleUpvote(event: CustomEvent) {
    console.log('handleUpvote', event);
    vote($authToken, event.detail, 10)
    workflowExecutions.update((o) => {
      o.data = o.data.slice(1);
      return o;
    })
  }

  function handleDownvote(event: CustomEvent) {
    console.log('handleDownvote', event);
    vote($authToken, event.detail, -10)
  }

  function handleToggleShowInput(event: CustomEvent) {
    console.log('handleToggleShowInput', event);
    showResult = !showResult;
  }
</script>

<Auth0Context
    domain="process.env.AUTH0_DOMAIN"
    client_id="process.env.AUTH0_CLIENT_ID"
    audience="process.env.AUTH0_AUDIENCE"
    callback_url="process.env.AUTH0_CALLBACK_URL"
    logout_url="process.env.AUTH0_CALLBACK_URL"
>
  <main>
    <AppHeader/>
    {#if !$isAuthenticated}
      <div>not authenticated</div>
    {:else if $workflowExecutions.loading}
      <div>loading executions ...</div>
    {:else if $workflowExecutions.error}
      <div>error loading executions!</div>
    {:else}
      <ImageContainer/>
      <AppFooter
          toggleImageMessage={showResult ? 'Show Input' : 'Show Result'}
          on:upvote={handleUpvote}
          on:downvote={handleDownvote}
          on:toggleShowInput={handleToggleShowInput}
      />
    {/if}
  </main>
</Auth0Context>

<style>
    main {
        height: 100%;
        width: 100%;
        display: flex;
        flex-direction: column;
    }

    main div {
        flex: 1 1 auto;
        display: flex;
        justify-content: center;
        flex-direction: column;
        text-align: center;
    }
</style>
